import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useDeleteRate, useRatesQuery, useZonesQuery } from "../api/queries";
import { RatesTour, useRatesTour } from "../tour";
import { RatesFilter } from "../ui/RatesFilter";
import { RatesTable } from "../ui/RatesTable";
import { RatesToolbar } from "../ui/RatesToolbar";

export function RatesPage() {
  const nav = useNavigate({ from: "/app/shipping/rates" });
  const search: OffsetPageQueryDTO = useSearch({ from: "/app/shipping/rates" });
  const { run, handleJoyrideCallback, startTour } = useRatesTour();
  const list = useRatesQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });
  const zonesQuery = useZonesQuery();
  const zones = zonesQuery.data ?? [];
  const canManage = useActionPermission(["shipping:create"]);
  const deleteRate = useDeleteRate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ອັດຕາຄ່າສົ່ງ" },
          ]}
        />
      </Header>
      <Main>
        <RatesToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/shipping/rates/new" })}
          onStartTour={startTour}
        />
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <RatesFilter zones={zones} />
          <RatesTable
            canManage={!!canManage}
            zones={zones}
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            sortBy={search.sort?.[0]?.field}
            sortOrder={search.sort?.[0]?.dir as "asc" | "desc" | undefined}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onEdit={(row) =>
              nav({
                to: "/app/shipping/rates/$id/edit",
                params: { id: row.id },
              })
            }
            onDelete={(id) =>
              toast.promise(deleteRate.run(id), {
                loading: "ກຳລັງລຶບ...",
                success: "ລຶບສຳເລັດ",
                error: "ລຶບລົ້ມເຫຼວ",
              })
            }
          />
        </div>
        <RatesTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
